var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCleanser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "-12 -12 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.73438 0V7.73438H5.80078V11.6016H21.2695V7.73438H19.3359V3.86719H28.2033L31.504 7.16783L34.2381 4.43373L29.8045 0H7.73438Z",
    fill: "#008FDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5352 52.3379C46.5352 53.4029 47.4019 54.2695 48.4688 54.2695C49.5338 54.2695 50.4023 53.4028 50.4023 52.3359C50.3853 51.743 49.581 50.0587 48.4688 48.1855C47.3546 50.0624 46.5502 51.7468 46.5352 52.3379Z",
    fill: "#008FDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2656 31.0664V27.1992H38.6719V31.0664H35.5431C32.2221 37.7764 30.9375 43.8484 30.9375 48.4688C30.9375 53.0846 32.219 59.2836 35.5431 66H61.3946C64.7155 59.2898 66 53.0891 66 48.4688C66 43.8529 64.7185 37.7828 61.3944 31.0664H58.2656ZM48.4688 58.1367C45.2701 58.1367 42.668 55.5346 42.668 52.3359C42.668 49.8642 45.6118 45.3361 46.8769 43.5026L48.4688 41.199L50.0606 43.5026C51.3257 45.3361 54.2695 49.8642 54.2695 52.3359C54.2695 55.5346 51.6674 58.1367 48.4688 58.1367Z",
    fill: "#008FDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6719 11.6016H58.2656V23.332H38.6719V11.6016Z",
    fill: "#008FDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6016 44.6035C11.6016 45.6684 12.4683 46.5352 13.5352 46.5352C14.6002 46.5352 15.4688 45.6684 15.4688 44.6016C15.4517 44.0086 14.6474 42.3243 13.5352 40.4512C12.421 42.328 11.6166 44.0125 11.6016 44.6035Z",
    fill: "#008FDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 58.1367H27.0703V66H0V58.1367Z",
    fill: "#008FDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15.4688H27.0703V23.332H0V15.4688Z",
    fill: "#008FDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0703 27.1992H0V54.2695H27.0703V27.1992ZM13.5352 50.4023C10.3365 50.4023 7.73438 47.8002 7.73438 44.6016C7.73438 42.1298 10.6782 37.6017 11.9433 35.7683L13.5352 33.4646L15.127 35.7683C16.3921 37.6017 19.3359 42.1298 19.3359 44.6016C19.3359 47.8002 16.7338 50.4023 13.5352 50.4023Z",
    fill: "#008FDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_82"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleanser);
export default __webpack_public_path__ + "static/media/cleanser.61f634f384345e850686af14cb9dcb12.svg";
export { ForwardRef as ReactComponent };